<template>
  <div :class="$style.base">
    <div
      :class="$style.picture"
      v-if="imageUrl"
      :style="`background-image: url(${imageUrl})`"
      v-test="'location-visual'"
    ></div>
    <div :class="$style.info">
      <div :class="$style.name">
        {{ location.name }}
      </div>
      <div>
        {{ location.address }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Location } from '@/types';
import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

const props = defineProps<{
  location: Location;
}>();

const { width } = useWindowSize();

const imageUrl = computed(() =>
  width.value < 500
    ? props.location.image_url_small
    : props.location.image_url_large
);
</script>

<style lang="scss" module>
.base {
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  @include box-shadow;

  &:not(:last-child) {
    margin-bottom: $spacing;
  }
}

.top {
  position: relative;
}

.picture {
  height: 150px;
  background-position: center center;
  background-size: cover;
}

.distance {
  position: absolute;
  right: $spacing;
  display: flex;
  align-items: center;
  height: 23px;
  padding: 0 $spacing 2px;
  font-size: 12px;
  color: white;
  border-radius: 17px;

  .base.hasPicture & {
    bottom: $spacing;
  }

  .base:not(.hasPicture) & {
    top: $spacing;
  }
}

.info {
  padding: $spacing;

  .base:not(.hasPicture) & {
    padding-right: 100px;
  }
}

.name {
  font-weight: bold;
}
</style>
